export const GET_SALES_INVOICE = gql`
    query GetSalesInvoice($id: String!) {
        invoice(id: $id) {
            id
            to
            date
            partner {
                id
                name
                business {
                    id
                    legalName
                }
                firstName
                lastName
                primaryContactInformation
                billingContactInformation
                countryDetails {
                    currencies {
                        symbol
                    }
                }
            }
            merchant {
                id
                sageContactId
                application
            }
            billingCycle
            occurrence
            occurrenceType
            frequency
            recurringStartDate
            numberOfInvoices
            totalOutstanding
            comments
            totalNetAmount
            totalVatAmount
            totalInvoiceAmount
            totalOutstanding
            invoiceItems {
                id
                ledgerAccount
                description
                netAmount
                totalNet
                totalVat
                lineTotal
                quantity
            }
            CreditNote {
                id
                sageCreditNoteId
                sageCreditNoteNumber
                reason
                totalCreditAmount
                totalCreditVatAmount
                totalCreditNetAmount
                createdAt
                creditNoteDate
                updatedAt
                status
                creditAllocatedBy {
                    id
                    firstName
                    lastName
                }
                creditUnallocatedBy {
                    id
                    firstName
                    lastName
                }
            }
            status
            createdAt
            sageInvoiceId
            sageInvoiceNumber
            sageInvoiceStatus
            paymentAllocations {
                id
                amount
                sagePaymentId
                paymentMethod
                status
                unallocatedAt
                allocatedAt
                paymentAllocatedBy {
                    id
                    firstName
                    lastName
                }
                paymentUnallocatedBy {
                    id
                    firstName
                    lastName
                }
            }
            user {
                firstName
                lastName
            }
            salesInvoiceReason
        }
    }
`;
